import { render, staticRenderFns } from "./NewModifier.vue?vue&type=template&id=9fda946c&scoped=true&"
import script from "./NewModifier.vue?vue&type=script&lang=js&"
export * from "./NewModifier.vue?vue&type=script&lang=js&"
import style0 from "./NewModifier.vue?vue&type=style&index=0&id=9fda946c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fda946c",
  null
  
)

export default component.exports